<template>
  <div class="manual-container">
    <p class="component-title">{{ $t('PEER.UploadEvaluation.title') }}</p>
    <div>
      <FileUploader :isUploaded="isUploaded" @toggleUpload="toggleUpload" />
      <p v-if="!isUploaded" class="text-danger">{{ $t('PEER.UploadEvaluation.uploadMessage') }}</p>
    </div>
    <div v-if="isUploaded">
      <p class="subTitle">{{ $t('PEER.UploadEvaluation.subtitle') }}</p>
      <FileSetting />
    </div>
    <div class="button-wrapper">
      <button @click="() => moveNextStep()">{{ $t('PEER.UploadEvaluation.next') }}</button>
    </div>
  </div>
</template>

<script>
import FileUploader from './FileUploader.vue';
import FileSetting from './FileSetting.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'CreateEvaluationPaper',
  components: {
    FileUploader,
    FileSetting,
  },
  data() {
    return {
      isUploaded: false,
    };
  },
  methods: {
    ...mapActions('modal', ['AC_MODAL_OPEN']),
    ...mapActions('peerPaper', ['AC_MOVE_NEXT_EVALUTATION_STEP']),
    toggleUpload(type) {
      this.isUploaded = type;
    },
    moveNextStep() {
      if (this.paperTitle) {
        this.AC_MOVE_NEXT_EVALUTATION_STEP();
      } else {
        const content =
          this.$i18n.locale === 'eng'
            ? `You haven't finished setting up your evaluation sheet.`
            : '평가지 설정이 완료되지 않았습니다.';
        const url = '';
        this.AC_MODAL_OPEN({
          content: content,
          url: url,
        });
      }
    },
  },
  computed: {
    ...mapState('peerPaper', {
      paperTitle: (state) => state.title,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
